
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FonteOrcamentariaService {

  constructor() { }

  public buscarFonteOrcamentaria(): {
    id: number,
    nome: string,
    modalidades: { id: number, nome: string }[]
  }[] {
    return [
      {
        id: 1,
        nome: 'Não se aplica',
        modalidades: [
          { id: 1, nome: 'Leilão - Eletrônico' },
          { id: 10, nome: 'Manifestação de Interesse' },
          { id: 12, nome: 'Leilão - Presencial' },
          { id: 11, nome: 'Pré-qualificação' },
          { id: 5, nome: 'Credenciamento' },
          { id: 13, nome: 'Registro de Preço' }
        ]
      },
      {
        id: 2,
        nome: 'Municipal',
        modalidades: [
          { id: 2, nome: 'Diálogo Competitivo' },
          { id: 7, nome: 'Concorrência' },
          { id: 4, nome: 'Concorrência – Eletrônica' },
          { id: 6, nome: 'Concorrência – Presencial' },
          { id: 8, nome: 'Pregão - Eletrônico' },
          { id: 9, nome: 'Pregão - Presencial' },
          { id: 3, nome: 'Dispensa' },
          { id: 14, nome: 'Inexigibilidade de Licitação' }
        ]
      },
      {
        id: 3,
        nome: 'Estadual',
        modalidades: [
          { id: 2, nome: 'Diálogo Competitivo' },
          { id: 7, nome: 'Concorrência' },
          { id: 4, nome: 'Concorrência – Eletrônica' },
          { id: 6, nome: 'Concorrência – Presencial' },
          { id: 8, nome: 'Pregão - Eletrônico' },
          { id: 9, nome: 'Pregão - Presencial' },
          { id: 3, nome: 'Dispensa' },
          { id: 14, nome: 'Inexigibilidade de Licitação' }
        ]
      },
      {
        id: 4,
        nome: 'Federal',
        modalidades: [
          { id: 2, nome: 'Diálogo Competitivo' },
          { id: 7, nome: 'Concorrência' },
          { id: 4, nome: 'Concorrência – Eletrônica' },
          { id: 6, nome: 'Concorrência – Presencial' },
          { id: 8, nome: 'Pregão - Eletrônico' },
          { id: 9, nome: 'Pregão - Presencial' },
          { id: 3, nome: 'Dispensa' },
          { id: 14, nome: 'Inexigibilidade de Licitação' }
        ]
      },
      {
        id: 5,
        nome: 'Organismo Internacional',
        modalidades: [
          { id: 2, nome: 'Diálogo Competitivo' },
          { id: 7, nome: 'Concorrência' },
          { id: 4, nome: 'Concorrência – Eletrônica' },
          { id: 6, nome: 'Concorrência – Presencial' },
          { id: 8, nome: 'Pregão - Eletrônico' },
          { id: 9, nome: 'Pregão - Presencial' },
          { id: 3, nome: 'Dispensa' },
          { id: 14, nome: 'Inexigibilidade de Licitação' }
        ]
      },
      {
        id: 6,
        nome: 'Distrital',
        modalidades: [
          { id: 2, nome: 'Diálogo Competitivo' },
          { id: 7, nome: 'Concorrência' },
          { id: 4, nome: 'Concorrência – Eletrônica' },
          { id: 6, nome: 'Concorrência – Presencial' },
          { id: 8, nome: 'Pregão - Eletrônico' },
          { id: 9, nome: 'Pregão - Presencial' },
          { id: 3, nome: 'Dispensa' },
          { id: 14, nome: 'Inexigibilidade de Licitação' }
        ]
      }
    ];
  }

  public buscarFonteOrcamentariaPorModalidade(codigo: number): {
    id: number,
    nome: string,
    modalidades: { id: number, nome: string }[]
  }[] {
    return this.buscarFonteOrcamentaria()
      .filter(i => i.modalidades.some(m => m.id === codigo));
  }

}

